import React, { useState } from 'react';
import '../../Assets/Css/Soundtrack.css';
import saraku from '../../Assets/Images/soraku.svg';
import chill from '../../Assets/Images/chil.svg';
import pottu from '../../Assets/Images/pottu.svg';
import yerru from '../../Assets/Images/yerru.svg';

const songs = [
    {
        id: 1,
        title: "Lubber Pandhu - Chillanjirukkiye Video Song | Harish Kalyan, Attakathi Dinesh | Sean Roldan",
        description: "Harish Kalyan, Attakathi Dinesh | Sean Roldan",
        youtubeLink: "https://youtu.be/dvWdFMCC1-I?si=RBpG2Q9wPcAJt0jv",
        image: chill,
        details: {
            lyrics: "Mohan Rajan",
            singers: "Pradeep Kumar | Sivaangi",
            release: "FROM TODAY 5 AM"
        }
    },
    {
        id: 2,
        title: "Nee Pottu Vechcha Video | Lubber Pandhu Version | Harish Kalyan | Attakathi Dinesh | Ilaiyaraaja",
        description: "Nee Pottu Vechcha Video | Lubber Pandhu Version | Harish Kalyan | Attakathi Dinesh | Ilaiyaraaja",
        image: pottu,
        youtubeLink: "https://youtu.be/-XANQcLQGu4?si=y3OUxXcgeJKwDN0v",
        details: {
            lyrics: "Mohan Rajan",
            singers: "Pradeep Kumar | Sivaangi",
            release: "FROM TODAY 5 AM"
        }
    },
    {
        id: 3,
        title: "Sardar - Yaerumayileri Video | Karthi, RaashiiKhanna | GV Prakash Kumar",
        description: "Karthi, Raashi Khanna | GV Prakash Kumar",
        image: yerru,
        youtubeLink: "https://youtu.be/LB2a6wMu29A?si=X3TlPo1eEZg4q8Uq",
        details: {
            lyrics: "Mohan Rajan",
            singers: "Pradeep Kumar | Sivaangi",
            release: "FROM TODAY 5 AM"
        }
    },
    {
        id: 4,
        title: "Sardar - Soraka Poove Video | Karthi, Rajisha Vijayan | GV Prakash Kumar",
        description: "Karthi, Rajisha Vijayan | GV Prakash Kumar",
        image: saraku,
        youtubeLink: "https://youtu.be/NS1YZlFQNns?si=NroVs31QveJg81Ps",
        details: {
            lyrics: "Mohan Rajan",
            singers: "Pradeep Kumar | Sivaangi",
            release: "FROM TODAY 5 AM"
        }
    },
];

const Soundtrack = () => {
    const [selectedSong, setSelectedSong] = useState(songs[0]);
    const [isPlaying, setIsPlaying] = useState(false);

    const extractVideoID = (url) => {
        const regex = /(?:youtube\.com\/(?:.*v=|.*\/|.*embed\/|.*watch\?.*v=)|youtu\.be\/)([^&?]+)/;
        const match = url.match(regex);
        return match ? match[1] : null;
    };

    const handleSongClick = (song) => {
        setSelectedSong(song);
        setIsPlaying(false); // Reset playing state when a new song is selected
    };

    const handlePlayClick = () => {
        setIsPlaying(true);
    };

    return (
        <div>
            {/* Header and Description */}
            <div className="soundtrack-header">
                <h3>Soundtrack of Our Stories</h3>
            </div>
            <div className="soundtrack-para">
                <p>Explore the unforgettable songs from our films that have captured hearts and elevated our storytelling.</p>
            </div>

            {/* Main Section */}
            <div className="soundtrack-container">
                <div className="soundtrack-background"></div>

                {/* Featured Video */}
                <div className="featured-video">
                    {isPlaying ? (
                        <iframe
                            width="100%"
                            height="100%"
                            src={`https://www.youtube.com/embed/${extractVideoID(selectedSong.youtubeLink)}`}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    ) : (
                        <div onClick={handlePlayClick}>
                            <img src={selectedSong.image} alt={selectedSong.title} />
                            <div className="play-button"></div>
                        </div>
                    )}
                </div>
                {/* Song List */}
                <div className="song-list">
                    
                    {songs.map((song) => (
                        <div
                            key={song.id}
                            className={`song-item ${selectedSong.id === song.id ? "active" : ""}`}
                            onClick={() => handleSongClick(song)}
                        >
                            <img src={song.image} alt={song.title} />
                            <p>{song.title}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Soundtrack;
